/// <reference path="../../../node_modules/react-datetime/react-datetime.d.ts" />

import * as React from 'react';
import * as calendarActions from './actions/CalendarActions';
import * as Actions from './actions/CalendarActions';
import notify from '../../shared/feedback/notifications';
import { FormGroup, Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { connect } from 'react-redux';
import { assign } from '../../shared/Assign';
import { IStylingUserCalendar } from './Types';
import ICalendar from '../calendar/ICalendar';
import StylingUserCalendarComponent from './StylingUserCalendarComponent';
import ICalendarItem, { ICalendarItemType } from '../calendar/Types';
import ItemTypes from '../../components/common/TreeView/ItemTypes';
import moment from 'moment';

interface IActions {
    getCalendar: (from: any, to: any) => any;
    updateCalendar: (calendar: any) => any;
    onCreated: (event: any) => Promise<any>;
    onUpdated: (event: any) => Promise<any>;
    onDeleted: (event: any) => Promise<any>;
}

interface IState {
    calendar: IStylingUserCalendar;
}

interface IProps {
    calendar: ICalendar;
    actions: IActions;
    user: any;
}

class StylingUserPersonalCalendar extends React.Component<IProps, IState> {
    constructor(props: IProps, context: any) {
        super(props, context);
        this.onCalendarChange = this.onCalendarChange.bind(this);
        this.onCreated = this.onCreated.bind(this);
        this.onUpdated = this.onUpdated.bind(this);
        this.onDeleted = this.onDeleted.bind(this);
        this.state = {
            calendar: {
                items: [],
                workingHours: [],
                se360WorkingHours: [],
                scandphotosWorkingHours: [],
                userIds: []
            }
        };
    }

    onCreated(event: any) {
        this.props.actions.onCreated(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onDeleted(event: any) {
        this.props.actions.onDeleted(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onUpdated(event: any) {
        this.props.actions.onUpdated(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onCalendarChange(calendar: ICalendar) {
        this.setState({ calendar: assign({}, calendar) });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({ calendar: assign({}, nextProps.calendar) });
    }

    updateCalendar() {
        let calendar = {
            items: this.state.calendar.items.map((item: any) => {
                return {
                    id: item.id,
                    userId: item.userId,
                    orderId: item.orderId,
                    title: item.title,
                    description: item.description,
                    type: item.type,
                    start: moment(item.start).format(),
                    end: moment(item.end).format(),
                    className: item.className,
                    site: item.site,
                    PhotographerInformation: item.PhotographerInformation,
                    FirmName: item.FirmName,
                    BrokerName: item.BrokerName,
                    BrokerDeliveryEmail: item.BrokerDeliveryEmail,
                    BrokerMobileNumber: item.BrokerMobileNumber
                };
            }),
            se360WorkingHours: this.state.calendar.se360WorkingHours
        };

        calendar.se360WorkingHours.map((x) => {
            x.start = moment(moment(x.start).toDate()).format('HH:mm:ss');
            x.end = moment(moment(x.end).toDate()).format('HH:mm:ss');
        });

        this.props.actions
            .updateCalendar({ calendar: calendar })
            .then((result: any) => {
                notify.success(Translate('photographers/calendar/toastr/success'));
            })
            .catch((error: any) => {
                notify.failure(Translate('photographers/calendar/toastr/error'));
            });
    }

    render() {
        let fixedCalendar = this.state.calendar;

        if (this.state.calendar.items) {
            fixedCalendar.items = this.state.calendar.items.map((item: ICalendarItem) => {
                let newItem = { ...item };
                if (newItem.type === ICalendarItemType.blocked) {
                    newItem.editable = true;
                }
                return newItem;
            });
        }

        return (
            <div>
                <FormGroup className="hidden-sm hidden-md hidden-lg">
                    <Button
                        bsStyle="primary"
                        onClick={() => {
                            this.updateCalendar();
                        }}
                    >
                        {Translate('photographers/calendar/page/button-label/save')}
                    </Button>
                </FormGroup>
                <StylingUserCalendarComponent
                    calendar={fixedCalendar}
                    onChange={(calendar: ICalendar) => {
                        this.onCalendarChange(calendar);
                    }}
                    onCreated={this.onCreated}
                    onUpdated={this.onUpdated}
                    onDeleted={this.onDeleted}
                    onRangeChanged={(from: any, to: any) => {
                        this.props.actions.getCalendar(from, to);
                    }}
                    user={this.props.user}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        calendar: state.stylingUserCalendar,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getCalendar: (from: any, to: any) => dispatch(Actions.getCalendar(from, to)),
            updateCalendar: (calendar: any) => dispatch(Actions.updateCalendar(calendar)),
            onCreated: (item: any) => dispatch(calendarActions.createCalendarItem(item)),
            onDeleted: (item: any) => dispatch(calendarActions.deleteCalendarItem(item)),
            onUpdated: (item: any) => dispatch(calendarActions.updateCalendarItem(item))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StylingUserPersonalCalendar);
